// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".call-center[data-v-9252d6b2] .ivu-form-item-label {\n  padding: 8px 7px;\n  background-color: #eee;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n  border: 1px solid #dddee1;\n}\n.call-center[data-v-9252d6b2] .ivu-select-selection {\n  border-radius: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
